import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import DyteText from './DyteText';
import { DyteUIContext } from '../lib/context-provider/ui-context';

export default function ({ meeting }) {
  const { storeStates } = useContext(DyteUIContext);
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { colors } = storeStates.designSystem;
  const title = meeting.meta.meetingTitle;
  const styles = StyleSheet.create({
    container: {
      alignItems: 'flex-start',
      justifyContent: 'center',
    },
    text: {
      fontWeight: 'bold',
    },
  });
  return (
    <View style={styles.container}>
      <DyteText style={styles.text}>{title}</DyteText>
    </View>
  );
}
